<template>
  <div class="content"  :style="curHeight && `height: ${curHeight}px`">
    <div class="background-index">
      <div class="top-title common">出国签证</div>
      <div class="middle-title common">Special service information</div>
      <div class="bottom-operator common">
        <BreadCrumbs />
      </div>
      <div class="common content-operator cgqz-2">
        <div class="common">
          <div class="content-middle">
            <img src="../../../assets/images/bg2.png" alt="遮罩图片" />
            <div class="mask-title">
              <p>{{ returnTitle(true) }}</p>
              <p></p>
            </div>
            <div class="scroll">
              <div
                v-for="item in list"
                :key="item.contentCode"
                :class="
                  getFocus(item.contentCode) === 'focus'
                    ? 'focus-list list-content'
                    : 'list-content'
                "
                @click="
                  () => {
                    goDetail(item.contentCode, item.contentTitle);
                  }
                "
                @mouseenter.stop="
                  () => {
                    setTarget(item.contentCode);
                    getCurrentEnameInfo(item.contentCode, item.tenantCode);
                  }
                "
              >
                <template>
                  <div class="nav-box">
                    <p>
                      <i v-if="item.contentTitle"></i>{{ item.contentTitle }}
                    </p>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <!-- <div class="content-right">
            <a-carousel autoplay :dots="false" ref="swiper">
              <img class="content-right" v-for="item in imgList" :key="item.fileCode" :src="item.fileHttpUrl">
            </a-carousel>
            <div class="arrow left-ar" @click="() => changeSwiper('prev')">
              <a-icon type="left" />
            </div>
            <div class="arrow right-ar" @click="() => changeSwiper('next')">
              <a-icon type="right" />
            </div>

            <a href="javascript:scroll(0,0)" id="to_top" target="_self" style="display:none;">向上</a>
          </div> -->
          <div class="content-right" >
            <div class="content-right-top" ref="right" v-if="currentEname!=''">
              <Content :data="detail" :open="isOpen" />
              <div class="more" v-show="!isOpen" @click="isOpen = true" >
                显示全文 <a-icon type="down"></a-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const list = [
  { name: "菲律宾个人旅游签证", ename: "Japan visa" },
  { name: "菲律宾探亲签证申请须知", ename: "Consular certification" },
  { name: "菲律宾商务签证申请须知", ename: "Translation Services" },
];
import BreadCrumbs from "@/components/home/breadCrumbs";
import {
  getNationalDetails,
  getNationalDetailsPic,
  getNationalPhoto,
} from "@/api/goaborad.js";
import {
  getOfficeDetailts
} from '@/api/service'
import { getFileDetails } from "@/api/file.js";
import Content from './siderContent-01.vue'
export default {
  name: "office-service",
  components: {
    BreadCrumbs,
    Content
  },
  data() {
    return {
      list,
      currentEname: '',
      imgList: [],
      detail: {},
      isOpen: false,
      curHeight: '1230',
    };
  },
  computed: {
    getFocus () {
      return function (val) {
        return this.currentEname === val ? 'focus' : ''
      }
    }
  },
  // watch: {
  //   open: function (val) {
  //     this.$nextTick(() => {
  //       if (!val) {
  //         this.curHeight = '1230'
  //         return
  //       }
  //       this.curHeight = this._.get(this, '$refs.right.scrollHeight', '1000') + 460
  //       this.curHeight = 1230
  //       // console.log(this.curHeight, 123, this._.get(this, '$refs.right.scrollHeight', '1000'))
  //     })
  //   }
  // },
  async created () {
    window.scrollTo(0,0)
    await this.getList()
    this.currentEname = this._.get(this.list, '0.contentCode', '')
    const tenantCode = this._.get(this.list, '0.tenantCode', '')
    this.getCurrentEnameInfo(this.currentEname, tenantCode)
  },
  mounted() {
    // this.toTop();
  },
  methods: {
    // 跳转到此页后展示顶部
    toTop() {
      let to_top = document.getElementById("to_top");
      to_top.click();
    },
    goDetail(contentCode, contentTitle) {
      const type = "contentAnnounce";
      this.pushRouter(
        `/guide?contentCode=${contentCode}&type=${type}&linkname=出国签证/${contentTitle}/详情`
      );
    },
    returnTitle(isChinese = false) {
      return this.$route.query.name;
    },
    changeSwiper(name) {
      this.$refs.swiper && this.$refs.swiper[name]();
    },
    setTarget(ename) {
      // if (!ename) return;
      this.isOpen = false
      this.currentEname = ename;
    },
    //获取当前栏目的详情
    getCurrentEnameInfo(contentCode,tenantCode){
      getOfficeDetailts(contentCode, tenantCode).then(res => {
        this.detail = this._.get(res, 'data', {})
        console.log(this.detail,'子栏目详情====》')
      })
    },
    async getList() {
      const moduleCode1 = this.$route.query.moduleCode1;
      const res = await getNationalDetails(moduleCode1);
      this.list = this._.get(res, "data.records", []);
      console.log('多国签证---',this.list)
      console.log(!this.isOpen,'多国签证---isOpen')
      return
      getNationalDetails(moduleCode1).then((res) => {
        this.list = this._.get(res, "data.records", []);
      });
      const moduleCode2 = this.$route.query.moduleCode2;
      getNationalDetailsPic(moduleCode2).then(async (res) => {
        let list = this._.get(res, "data.records", []);
        this.imgList = JSON.parse(JSON.stringify([]));
        for (let i of list) {
          const resI = await getNationalPhoto(i.picCode, i.tenantCode);
          const img = await getFileDetails(
            this._.get(resI, "data.appCode", ""),
            this._.get(resI, "data.tenantCode"),
            [this._.get(resI, "data.contentPicFileDtoList.0.fileCode", "")]
          );
          this.imgList.push(
            this._.get(Object.values(this._.get(img, "data")), "0")
          );
        }
      });
    },
  },
};
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  // height: 938px;
  margin-bottom: 30px;
}
.background-index {
  height: 190px;
  width: 100%;
  position: absolute;
  index: -1;
  background-image: url("../../../assets/images/icon_visa_bg.png");
  // background-size: 100% 100%;
  background-repeat: no-repeat;
  // background-position: center;
}
.top-title {
  width: 100%;
  height: 65px;
  font-size: 50px;
  font-family: Alibaba PuHuiTi;
  font-weight: bold;
  color: #ffffff;
  line-height: 30px;
  top: 60px;
}
.middle-title {
  width: 736px;
  height: 31px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  top: 130px;
}
.common {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.bottom-operator {
  width: 100%;
  height: 120px;
  top: 190px;
  left: 0;
  transform: translateX(0);
  background: white;
}
.content-operator {
  top: 290px;
  background: white;
  height: 480px;
  width: 100%;
  min-width: 1366px;
  > div {
    width: 1140px;
    display: flex;
  }
}
.content-middle {
  width: 320px;
  height: 400px;
  position: relative;

  img {
    margin: -20px 50 30px 0;
    // margin-right: 50px;
    // border: 1px solid #e5e5e5;
    background-color: #fff;
  }
  .mask-title {
    position: absolute;
    top: 21px;
    left: 0;
    width: 100%;

    p {
      margin: 0;
      padding: 0;
      text-align: center;
      width: 100%;
    }
    p:nth-of-type(1) {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
    }
    p:nth-of-type(2) {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
    }
  }
}

.focus-list:hover {
  background: #cbb486;

  .nav-box {
    // border: none;
    p:nth-of-type(2) {
      color: white;
    }
    p:nth-of-type(1) {
      color: white;
    }
    i {
      background: white;
      vertical-align: middle;
    }
  }
}
.content-right {
  width: 820px;
  min-height: 753px;
  margin-top: 20px;
  position: relative;
  border: 1px solid #ebebeb;
  -webkit-box-shadow: 2px 2px 8px 2px #f8f8f8;
  -moz-box-shadow: 2px 2px 8px 2px #f8f8f8;
  box-shadow: 2px 2px 2px 2px #f8f8f8;
  .content-right-top {
    position: relative;
    // height: 680px; 
    // overflow: hidden;
  }
}
.swiper {
  height: 587px;
}
.arrow {
  width: 42px;
  height: 70px;
  opacity: 0.64;
  position: absolute;
  font-size: 30px;
  line-height: 70px;
  cursor: pointer;
  color: white;
}
.right-ar {
  top: 45%;
  right: 0;
}
.left-ar {
  top: 45%;
  left: 0;
}
.scroll {
  overflow-y: scroll;
  border: 1px solid #e5e5e5;
  height: 401px;
  margin-top: 20px;
}
.more {
  color: #cdad7f;
  font-size: 16px;
  cursor: pointer;
}
.icon-img {
  position: absolute;
  left: 35px;
  top: 25px;
}
.list-content:not(:last-of-type) {
  border-left: 1px solid #E5E5E5;
  border-right: 1px solid #E5E5E5;
  border-top: 1px solid #E5E5E5;
}
.list-content:last-of-type {
  border: 1px solid #E5E5E5;
}
.list-content {
  cursor: pointer;
  display: flex;
  padding: 12px 0;
  height: 80px;
  img {
    width: 32px;
    height: 32px;
    transform: translateY(10px);
    margin: 0 29px 0 24px;
  }
  .nav-box {
    position: relative;
    padding: 0 40px;
    i {
      display: inline-block;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #7F7F7F;
      vertical-align: middle;
      margin: 0 6px 0 0px;
    }
    p {
      margin: 0;
      padding: 0;
      text-align: left;
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    p:nth-of-type(1) {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 24px;
      padding-top: 7px;
    }
    p:nth-of-type(2) {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7F7F7F;
      line-height: 14px;
      padding-top: 10px;
    }
  }
}
.focus-list {
  background: #CBB486;
  .nav-box {
    p:nth-of-type(2) {
      color: white;
    }
    p:nth-of-type(1) {
      color: white;
    }
    i {
      background: white;
      vertical-align: middle;
    }
  }
}
.more {
    color: #cdad7f;
    font-size: 16px;
    cursor: pointer;
    position: absolute;
    left: 45%;
}
</style>



// WEBPACK FOOTER //
// src/components/content/specialService/index.vue